import axios from "axios";
import apis from "./index";

export const createSignup = async (data) => {
  console.log(data, "i am data from signup api call");

  let config = {
    method: "POST",
    url: apis.signup.register,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data,
  };
  console.log("Config", config);
  try {
    console.log("before signup api");
    const response = await axios(config);
    console.log("Response+__>", response);
    return response.data;
  } catch (e) {
    console.log(e, "iam error");
    throw e;
  }
};
